import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from 'axios';

interface Product {
  id: number;
  product_name: string;
  price_usd: number;
  location: string;
  description: string;
  details: string;
  variation_id: number;
}

const API_BASE = process.env.REACT_APP_API_URL;

const ProductGrid: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await axios.get(`${API_BASE}/api/products`);
      setProducts(response.data);
    };
    fetchProducts();
  }, []);

  const handleProductClick = (product: Product) => {
    navigate(`/product/${product.id}?variation=${product.variation_id}`);
  };

  return (
    <Container sx={{ marginTop: 4, mb: 4 }}>
      <Grid container spacing={4}>
        {products.map((product) => (
          <Grid item key={product.variation_id} xs={12} sm={6} md={4}>
            <Card onClick={() => handleProductClick(product)} style={{ cursor: 'pointer'}}>
              <CardMedia
                component="img"
                height="300"
                image={product.location}
                alt={product.product_name}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {product.product_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ${product.price_usd}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ProductGrid;